import { z } from "zod";
import { orientationSchema, storeLinkSchema } from "./catalog";
import { isoDateTime } from "./common";

export const CATALOG_SNAPSHOT_VERSION = 1;

export const snapshotCategorySchema = z.object({
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  iconName: z.string(),
  colorPrimary: z.string().nullable(),
  colorSecondary: z.string().nullable(),
  isFeatured: z.boolean(),
  showInMenu: z.boolean(),
  sortOrder: z.number().int(),
});
export type SnapshotCategory = z.infer<typeof snapshotCategorySchema>;

export const snapshotGameSchema = z.object({
  slug: z.string(),
  name: z.string(),
  categorySlug: z.string(),
  iconUrl: z.string(),
  previewUrl: z.string(),
  thumbnailUrl: z.string().nullable(),
  orientation: orientationSchema,
  backgroundColor: z.string().nullable(),
  author: z.string().nullable(),
  releaseDate: z.string().nullable(),
  briefDescription: z.string().nullable(),
  description: z.string().nullable(),
  seoTitle: z.string().nullable(),
  seoDescription: z.string().nullable(),
  isOriginal: z.boolean(),
  isPopular: z.boolean(),
  isNew: z.boolean(),
  sortOrder: z.number().int(),
  publishedAt: isoDateTime.nullable(),
  ratingValue: z.number().nullable(),
  ratingCount: z.number().int().nullable(),
  adsenseEligible: z.boolean(),
  /** When an editor last confirmed the page meets the ad-content bar; null if never reviewed. */
  editorialReviewedAt: isoDateTime.nullable().default(null),
  disableAdblockNotice: z.boolean(),
  likeCount: z.number().int(),
  storeLinks: z.array(storeLinkSchema),
  /**
   * Direct embed URL used only when the runtime play API is unreachable. Present only for games
   * whose delivery does not depend on the visitor's region or authentication.
   */
  playFallbackUrl: z.string().nullable(),
});
export type SnapshotGame = z.infer<typeof snapshotGameSchema>;

export const catalogSnapshotSchema = z.object({
  schemaVersion: z.literal(CATALOG_SNAPSHOT_VERSION),
  generatedAt: isoDateTime,
  categories: z.array(snapshotCategorySchema),
  games: z.array(snapshotGameSchema),
});
export type CatalogSnapshot = z.infer<typeof catalogSnapshotSchema>;
